import clsx from 'clsx'
import { FC } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import styles from './auth-layout.module.scss'
import { RouteEnum } from '../../constants/routes.enum'
import { AuthHeader } from '../../modules/auth/auth.header'

export const AuthLayout: FC = () => {
  const location = useLocation()

  const hasProgress = location.pathname === `/${RouteEnum.ONBOARDING}`

  return (
    <>
      <AuthHeader hasProgress={hasProgress} />
      <div className={clsx(styles.contentWrapper)}>
        <Outlet />
      </div>
    </>
  )
}
